/** @module Enums */ /** typedoc */

export enum SubscriptionStatusEnum {
    Active = 'Active',
    PendingPlanChange = 'PendingPlanChange',
    Suspended = 'Suspended',
}
